import axios from 'axios'
import {API_ENDPOINT} from '../../config'

const all = (instance, params) => {
    instance.setState({ ...instance.state, loadingUsers: true })
    axios({
        method: 'post',
        url: API_ENDPOINT + "/users",
        headers: {
            "Authorization": instance.props.auth.authorization
        },
        data: params
    }).then(response => handleLoadUsersResponse(instance, response))
        .catch(error => {
            instance.setState({
                ...instance.state,
                loadingUsers: false
            })
            alert(error)
        })
}

const handleLoadUsersResponse = (instance, response) => {
    switch (response.data.status) {
        case 200:
            instance.setState({
                ...instance.state,
                loadingUsers: false,
                users: response.data.data.users
            })
            break;
        case 403:
            instance.props.history.push('/auth/login')
            break;
        default:
            instance.setState({
                ...instance.state,
                loadingUsers: false
            })
            alert(response.data.message)
    }
}

const one = (instance, params) => {
    instance.setState({ ...instance.state, loadingUser: true })
    axios({
        method: 'post',
        url: API_ENDPOINT + "/user",
        headers: {
            "Authorization": instance.props.auth.authorization
        },
        data: params
    }).then(response => handleLoadUserResponse(instance, response))
        .catch(error => {
            instance.setState({
                ...instance.state,
                loadingUser: false
            })
            alert(error)
        })
}

const handleLoadUserResponse = (instance, response) => {
    switch (response.data.status) {
        case 200:
            instance.setState({
                ...instance.state,
                loadingUser: false,
                user: response.data.data.user
            })
            break;
        case 403:
            instance.props.history.push('/auth/login')
            break;
        default:
            instance.setState({
                ...instance.state,
                loadingUser: false
            })
            alert(response.data.message)
    }
}

const UserDatasource = () => {
    return {
        all: (instance, params) => all(instance, params),
        one: (instance, params) => one(instance, params)
    }
}

export default UserDatasource